export function createTabsProjection({
  hostAdapter,
  findLoadedEntities,
  toPaneKey,
  parseUpdatedAtMs,
}) {
  const buildPane = (element, activeKey, index) => {
    const key = toPaneKey(element);
    if (!key) {
      return null;
    }

    const type = String(element.type || '');
    const isAutosaveSupportedType = type === 'reaction' || type === 'sample';
    const isNewForAutosave = isAutosaveSupportedType && element.isNew === true;
    const isDirty = Boolean(element.isPendingToSave || element.changed);
    const canSave = isDirty && element.can_update === true && !isNewForAutosave;
    const numericId = Number.parseInt(String(element.id), 10);
    const reviewState = type === 'reaction'
      ? hostAdapter.normalizeReviewState(element?.chemkit?.review?.state)
        || hostAdapter.getRememberedReviewState(numericId)
      : null;

    return {
      key,
      type,
      id: String(element.id),
      isNew: isNewForAutosave,
      isDirty,
      canSave,
      isOpen: true,
      isActive: index === activeKey,
      updatedAtMs: parseUpdatedAtMs(element.updated_at),
      reviewState,
    };
  };

  const getAllTabs = () => {
    const { selecteds = [], activeKey = 0 } = hostAdapter.readTabsState();
    const panes = [];

    selecteds.forEach((entry, index) => {
      if (!entry || Array.isArray(entry)) return;
      const pane = buildPane(entry, activeKey, index);
      if (pane) panes.push(pane);
    });

    return panes;
  };

  const getSampleInfoForReactionId = (reactionId) => {
    const numericReactionId = Number.parseInt(String(reactionId), 10);
    if (!Number.isFinite(numericReactionId) || numericReactionId <= 0) {
      return [];
    }

    const reactions = findLoadedEntities(numericReactionId, 'reaction');
    const reaction = reactions[0];

    if (!reaction || !Array.isArray(reaction.samples)) {
      return [];
    }

    const unique = new Map();
    reaction.samples.forEach((sample) => {
      if (!sample) {
        return;
      }

      const sampleId = Number.parseInt(String(sample.id), 10);
      if (!Number.isFinite(sampleId) || sampleId <= 0) {
        return;
      }

      unique.set(sampleId, {
        id: sampleId,
        updatedAtMs: parseUpdatedAtMs(sample.updated_at),
      });
    });

    return Array.from(unique.values());
  };

  const getActiveTab = () => {
    const panes = getAllTabs();
    const active = panes.find((pane) => pane.isActive);
    return active || null;
  };

  return {
    getAllTabs,
    getSampleInfoForReactionId,
    getActiveTab,
  };
}
